import React from 'react';
import Card from '../Card';
import { recipesData } from '../../../data/regionalChef/recipesData'; 

const GameBoard = ({ gameLogic }) => {
  const { 
    day, ap, money, dailySales, dailyTarget, inventory, deck, selectedIndices, // 👈 ใช้ dailySales และ dailyTarget
    showPopup, activeBuffs, currentModifier, showRecipeBook, unlockedRecipes, recipeLevels,
    toggleCardSelection, performAction, serveFood, discardAndDraw, closePopup, toggleRecipeBook 
  } = gameLogic;

  const actionButtons = [
    { id: 'action_chop', label: 'สับ 🔪' }, 
    { id: 'action_pound', label: 'โขลก 🥣' },
    { id: 'action_mix', label: 'คลุก 🥗' },
    { id: 'action_boil', label: 'ต้ม 🍲' }, 
    { id: 'action_stir_fry', label: 'ผัด 🍳' },
    { id: 'action_fry', label: 'ทอด 🥘' },
    { id: 'action_grill', label: 'ย่าง ♨️' }
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh', backgroundColor: '#fdfdfd', fontFamily: 'sans-serif' }}>
      
      {/* 1. Header & Stats */}
      <header style={{ padding: '15px', backgroundColor: '#fff', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', zIndex: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <h3 style={{ margin: '0 0 5px 0', color: '#2f3542', fontSize: '16px' }}>📅 วันที่ {day}</h3>
            {/* ⚠️ โชว์ยอดขายแยกกับกระเป๋าเงิน */}
            <h2 style={{ margin: '0 0 5px 0', fontSize: '20px', color: '#2ed573' }}>
              ยอดขาย: ฿{dailySales} <span style={{ color: '#a4b0be', fontSize: '14px' }}>/ ฿{dailyTarget}</span>
            </h2>
            <p style={{ margin: 0, fontSize: '13px', color: '#57606f', fontWeight: 'bold' }}>💰 กระเป๋าเงิน: ฿{money}</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <h2 style={{ margin: '0 0 5px 0', color: '#ff4757', fontSize: '24px' }}>⚡ {ap}</h2>
            <button onClick={toggleRecipeBook} style={{ padding: '5px 10px', fontSize: '12px', backgroundColor: '#3742fa', color: 'white', border: 'none', borderRadius: '4px' }}>📖 ดูสูตรอาหาร</button>
          </div>
        </div>

        <div style={{ marginTop: '10px', padding: '8px', backgroundColor: currentModifier.color, color: 'white', borderRadius: '6px', fontSize: '12px', textAlign: 'center', fontWeight: 'bold' }}>
          ⚠️ เงื่อนไข: {currentModifier.name} - {currentModifier.desc}
        </div>
      </header>

      {/* 2. Play Area */}
      <div style={{ flexGrow: 1, overflowY: 'auto', padding: '20px 10px', display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', alignContent: 'flex-start' }}>
        {inventory.map((cardId, index) => {
          const isSelected = selectedIndices.includes(index);
          const isRecipe = cardId.startsWith('recipe_');
          return (
            <div key={`${cardId}-${index}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Card type={cardId} isSelected={isSelected} onClick={() => toggleCardSelection(index)} />
              {isRecipe && (
                <button 
                  onClick={() => serveFood(index)} 
                  style={{ marginTop: '8px', padding: '10px 15px', backgroundColor: '#ffa502', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', width: '100%', boxShadow: '0 4px 0 #e15f41' }}
                >
                  เสิร์ฟ (-1)
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* 3. Action Bar */}
      <div style={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', padding: '15px 10px', boxShadow: '0 -4px 15px rgba(0,0,0,0.05)', borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
           <span style={{ fontSize: '14px', color: '#57606f', fontWeight: 'bold' }}>แผงเครื่องมือ</span>
           <span style={{ fontSize: '12px', color: '#a4b0be' }}>📦 กองการ์ด: {deck.length} ใบ</span>
        </div>
        
        <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '5px' }}>
          {actionButtons.map(action => (
            <button 
              key={action.id} onClick={() => performAction(action.id)} disabled={selectedIndices.length === 0} 
              style={{ flex: '1 0 20%', padding: '12px 5px', fontSize: '14px', fontWeight: 'bold', backgroundColor: selectedIndices.length > 0 ? '#3742fa' : '#dfe4ea', color: selectedIndices.length > 0 ? 'white' : '#747d8c', border: 'none', borderRadius: '8px' }}
            >
              {action.label}
            </button>
          ))}
          <button 
            onClick={discardAndDraw} disabled={selectedIndices.length === 0 || deck.length === 0} 
            style={{ flex: '1 0 20%', padding: '12px 5px', fontSize: '14px', fontWeight: 'bold', backgroundColor: (selectedIndices.length > 0 && deck.length > 0) ? '#ff4757' : '#dfe4ea', color: (selectedIndices.length > 0 && deck.length > 0) ? 'white' : '#747d8c', border: 'none', borderRadius: '8px' }}
          >
            ทิ้ง 🔄
          </button>
        </div>
      </div>

      {/* 4. Modal: Recipe Book */}
      {showRecipeBook && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 100, display: 'flex', flexDirection: 'column' }}>
          <div style={{ backgroundColor: 'white', margin: '40px 20px', borderRadius: '12px', flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ padding: '15px', borderBottom: '1px solid #ccc', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0 }}>📖 สมุดสูตรที่ค้นพบ ({unlockedRecipes.length}/20)</h3>
              <button onClick={toggleRecipeBook} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>❌</button>
            </div>
            <div style={{ padding: '15px', overflowY: 'auto', flexGrow: 1, backgroundColor: '#f8f9fa' }}>
              {unlockedRecipes.length === 0 ? (
                 <p style={{ textAlign: 'center', color: '#a4b0be', marginTop: '50px' }}>ยังไม่ค้นพบสูตรอาหารใดๆ<br/>ทดลองผสมวัตถุดิบดูสิ!</p>
              ) : (
                 unlockedRecipes.map(id => {
                   const recipe = recipesData[id];
                   const level = recipeLevels[id] || 1;
                   return (
                     <div key={id} style={{ backgroundColor: 'white', border: '1px solid #dfe4ea', padding: '15px', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', alignItems: 'center' }}>
                          <h4 style={{ margin: 0, fontSize: '18px', color: '#2f3542' }}>{recipe.name}</h4>
                          <span style={{ backgroundColor: '#ffa502', color: 'white', padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>Lv.{level} | ฿{recipe.basePrice + ((level - 1) * 15)}</span>
                        </div>
                        <div style={{ backgroundColor: '#f1f2f6', padding: '10px', borderRadius: '6px', marginBottom: '10px' }}>
                          <h5 style={{ margin: '0 0 5px 0', color: '#3742fa', fontSize: '13px' }}>🍳 วิธีทำ:</h5>
                          <ul style={{ margin: 0, paddingLeft: '20px', color: '#2f3542', fontSize: '13px', lineHeight: '1.5' }}>
                            {recipe.steps.map((step, idx) => (
                              <li key={idx}>{step}</li>
                            ))}
                          </ul>
                        </div>
                        <div style={{ fontSize: '13px', lineHeight: '1.5', color: '#57606f' }}>
                          {recipe.knowledge}
                        </div>
                     </div>
                   );
                 })
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GameBoard;